import { PluginTypes } from '../../types/enums/PluginTypes';

/**
 * Generates the DOM ID for a plugin button element
 * @param pluginType - The type of plugin
 * @param groupId - The group/funnel ID
 * @returns The formatted button ID (e.g., "plugin-button-meddic-plugin-abc123")
 */
export const getPluginButtonId = (pluginType: PluginTypes, groupId: string): string => {
  return `plugin-button-${pluginType}-${groupId}`;
};
